import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enLangCommon from '@/locales/en/common';
import enValidate from '@/locales/en/validate';
import jaLangCommon from '@/locales/ja/common';
import jaValidate from '@/locales/ja/validate';

Vue.use(VueI18n)
const langs = {
  en: {
    common: enLangCommon,
    validate: enValidate,
  },
  ja: {
    common: jaLangCommon,
    validate: jaValidate,
  },
};
const numberFormats = {
  'en': {
    currency: {
      style: 'currency', currency: 'USD', notation: 'standard'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  },
  'ja': {
    currency: {
      style: 'currency', currency: 'JPY', useGrouping: true, currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal'
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
}
const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'ja': {
    short: {
      month: 'long',
      day: 'numeric',
      weekday: 'short',
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short'
    },
    day: {
      weekday: 'short'
    },
  }
}
export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'ja',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ja',
  silentTranslationWarn: true,
  messages: langs,
  dateTimeFormats,
  numberFormats,
})
